import React, {useState} from 'react';
import b_ from 'b_';

import I18N from 'assets/i18n/brandlift-project';

import {SurveysGoal} from 'client/common/types';

import {Button} from 'client/common/components/lego';
import {ModalProps} from 'client/common/components/survey-settings/types';

import {useSendGoalOnce} from 'client/common/hooks/metrika';

import './edit-settings.css';
import UnlockInterviewPopup from 'client/common/components/unlock-interview-popup';
import {useInterviewBalance} from 'client/common/hooks/payment';

const i18n = I18N.common.surveySettings.editSettingsModal;

const b = b_.with('edit-settings-modal');

export default function EditSettingsInverviews(props: ModalProps) {
    const {slug, onClose} = props;

    const [displayInterviewPopup, setDisplayInterviewPopup] = useState(false);
    const sendGoalOnce = useSendGoalOnce();

    const interviewBalance = useInterviewBalance();

    if (interviewBalance.status !== 'success') {
        return null;
    }

    const interviewTotal = interviewBalance.data?.total;

    return (
        <div className={b('interviews-title')}>
            {!displayInterviewPopup && (
                <>
                    <h5 className={b('action-title')}>{i18n.buyInterviewsBeforehand}</h5>

                    <p className={b('action-subtitle')}>
                        {i18n.buyInterviewSubtitle.replace('%s', String(interviewTotal))}
                    </p>
                </>
            )}

            {displayInterviewPopup && (
                <div className={b('interviews-wrapper')}>
                    <UnlockInterviewPopup
                        slug={slug}
                        initialCount={1}
                        formActionDefault='buy'
                        className='edit-settings-wrapper'
                        customTitle={i18n.actionTitle}
                        customSubtitle={i18n.buyInterviewSubtitle.replace(
                            '%s',
                            String(interviewTotal)
                        )}
                        onPaymentFinish={() => {
                            sendGoalOnce(SurveysGoal.StatisticsFinishPayment);
                            onClose();
                            location.reload();
                        }}
                    />
                </div>
            )}

            {!displayInterviewPopup && (
                <Button
                    view='dl-action'
                    size='m'
                    className={b('form-action-btn')}
                    onClick={() => setDisplayInterviewPopup(true)}
                >
                    {i18n.buyInterviews}
                </Button>
            )}
        </div>
    );
}
